import datepicker from 'js-datepicker';

export default function _newsSearchResults() {
    /**
     * Main wrapper selector.
     * @type {string}
     */
    const FORM_SELECTOR = '[data-component="news-search-results"]';
    const form = document.querySelector(FORM_SELECTOR);
    /**
     * Sorting hidden field.
     * @type {string}
     */
    const HIDDEN_SORT = 'input[name="sort"]';

    /**
     * Sorting hidden num ranks field.
     * @type {string}
     */
    const HIDDEN_NUM_RANKS = 'input[name="num_ranks"]';

    /**
     * Create a new Form handler functionality.
     * @param {HTMLElement} funnelback form - The wrapping HTML element of the form.
     * @class
     */

    const EVENT_DATEPICKER_HIDDEN_INPUT = '#event-date';

    const EVENT_DATEPICKER_INPUT_CLASS = [
        '.search-form__search-banner__form__select--event-date',
    ];

    const EVENT_DATEPICKER_INPUT_CLASSES = [
        '.search-form__search-banner__form__select--event-date-mobile',
        '.search-form__search-banner__form__select--event-date-desktop',
    ];

    const MOBILE_TABBED_FACET_SELECT =
        '.news-search__body__tabbed-facet-select';

    class NewsSearchResults {
        constructor(formWrapper) {
            // Outer wrapper for aside menu.
            this.formWrapper = formWrapper;
            // Gets hidden sort field.
            this.hiddenSort = this.formWrapper.querySelector(HIDDEN_SORT);
            // Gets hidden num_ranks field.
            this.hiddenNumRanks =
                this.formWrapper.querySelector(HIDDEN_NUM_RANKS);

            // Setup js datepicker instances.
            this.attachDatePicker();

            // Setup event listeners.
            this.attachChangeEvents();
        }

        padDate(n) {
            return n < 10 ? `0${n}` : n;
        }

        attachDatePicker() {
            const regularSearchSubmit = form.querySelector(
                '#regularSearchSubmit'
            );
            const eventDatepickers = document.querySelectorAll(
                EVENT_DATEPICKER_INPUT_CLASSES
            );

            if (eventDatepickers.length > 0) {
                EVENT_DATEPICKER_INPUT_CLASSES.forEach((inputClass) => {
                    datepicker(inputClass, {
                        customDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
                        minDate: new Date(),
                        position: 'br',
                        onSelect: (instance, date) => {
                            // Do stuff when a date is selected (or unselected) on the calendar.
                            // You have access to the datepicker instance for convenience.
                            const formattedDate = `${this.padDate(
                                date.getDate()
                            )}/${this.padDate(
                                date.getMonth() + 1
                            )}/${date.getFullYear()}`;

                            // below might be needed instead depending on what FB will accept as facet/ filter
                            // const formattedDate = date.toISOString();
                            // update the hidden field used for search form submission
                            const eventHiddenInput = document.querySelector(
                                EVENT_DATEPICKER_HIDDEN_INPUT
                            );
                            if (eventHiddenInput) {
                                eventHiddenInput.value = formattedDate;
                            }
                            // update all datepicker instances with the same value
                            document
                                .querySelectorAll(EVENT_DATEPICKER_INPUT_CLASS)
                                .forEach((dateInput) => {
                                    // eslint-disable-next-line no-param-reassign
                                    dateInput.value = formattedDate;
                                });

                            regularSearchSubmit.click();
                        },
                    });
                });
            }
        }

        /**
         * Attach event listeners to select fields.
         *
         * @returns void
         */
        attachChangeEvents() {
            const regularSearchSubmit = form.querySelector(
                '#regularSearchSubmit'
            );
            // const advancedSearchSubmit = form.querySelector(
            //     '#advancedSearchSubmit'
            // );
            const tabbedFacetSelect = form.querySelector(
                MOBILE_TABBED_FACET_SELECT
            );

            if (regularSearchSubmit) {
                const yearDropdown = form.querySelector('#year');

                if (yearDropdown) {
                    yearDropdown.addEventListener('change', (event) => {
                        regularSearchSubmit.click();
                    });
                }

                const dateDropdown = form.querySelector('#date');

                if (dateDropdown) {
                    dateDropdown.addEventListener('change', (event) => {
                        regularSearchSubmit.click();
                    });
                }

                const typeDropdown = form.querySelector('#type');

                if (typeDropdown) {
                    typeDropdown.addEventListener('change', (event) => {
                        regularSearchSubmit.click();
                    });
                }

                const categoryDropdown = form.querySelector('#category');

                if (categoryDropdown) {
                    categoryDropdown.addEventListener('change', (event) => {
                        regularSearchSubmit.click();
                    });
                }

                const locationDropdown = form.querySelector('#location');

                if (locationDropdown) {
                    locationDropdown.addEventListener('change', (event) => {
                        regularSearchSubmit.click();
                    });
                }

                const sortDropdown = document.querySelector('#sort');

                if (sortDropdown) {
                    sortDropdown.addEventListener('change', (event) => {
                        regularSearchSubmit.click();
                    });
                }

                const numRanksDropdown = document.querySelector('#num_ranks');

                if (numRanksDropdown) {
                    numRanksDropdown.addEventListener('change', (event) => {
                        regularSearchSubmit.click();
                    });
                }
            }

            if (tabbedFacetSelect) {
                tabbedFacetSelect.addEventListener('change', (event) => {
                    const url = event.target.value; // get selected value
                    if (url) {
                        // require a URL
                        window.location = url; // redirect
                        regularSearchSubmit.click();
                    }
                    return false;
                });
            }
        }
    }

    if (!form || form.handler) {
        return;
    }

    form.handler = new NewsSearchResults(form);
}

_newsSearchResults();
